var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-page"},[_vm._v(" This page is in the making ")])}
var staticRenderFns = []

export { render, staticRenderFns }